import { Button, Col, Form, Popconfirm, Radio, Row } from 'antd';
import { RadioChangeEvent } from 'antd/lib/radio';
import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router';
import { Panel } from 'src/components/Panel';

import { AdvancedDesposit } from './AdvancedDesposit';
import { LimitedTimeSale } from './LimitedTimeSale';

const LimitedTimeSaleForm: any = Form.create()(LimitedTimeSale);
const AdvancedDespositForm: any = Form.create()(AdvancedDesposit);

interface Props extends RouteComponentProps<{ id: string; name: string }> {}
interface State {
  activityType: string;
}

export class ConfigActivity extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      activityType: 'advancedDesposit',
    };
  }

  onActivityTypeChange = (e: RadioChangeEvent) => {
    this.setState({ activityType: e.target.value });
  };

  backPage = () => {
    this.props.history.goBack();
  };

  render() {
    const { activityType } = this.state;
    const { id: activityId, name } = this.props.match.params;

    return (
      <>
        <Panel style={{ padding: 24 }}>
          <Row>
            <Col span={10}>
              <h2>活动名称：{name}</h2>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <span>活动类型：</span>
              <Radio.Group onChange={this.onActivityTypeChange} value={activityType}>
                <Radio value="advancedDesposit">预付定金</Radio>
                <Radio value="limitedTimeSale">限时优惠</Radio>
              </Radio.Group>
            </Col>
          </Row>
        </Panel>
        <Row style={{ marginTop: 20 }}>
          <Col span={24}>
            {activityType === 'advancedDesposit' && <AdvancedDespositForm activityId={Number(activityId)} />}
            {activityType === 'limitedTimeSale' && <LimitedTimeSaleForm activityId={Number(activityId)} />}
          </Col>
        </Row>
        <Panel style={{ padding: 20, marginTop: 20 }}>
          <Row type="flex" justify="end">
            <Popconfirm
              placement="top"
              title={'是否确定返回上一页？'}
              onConfirm={this.backPage}
              okText="Yes"
              cancelText="No"
              style={{ marginRight: 5 }}
            >
              <Button type="primary" style={{ marginRight: 5 }}>
                返回活动列表
              </Button>
            </Popconfirm>
          </Row>
        </Panel>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/marketing/SetActivity.tsx